import React, { useEffect, useRef, useState } from "react"

import button1 from "../../assets/images/button1.png"
import moment from "moment-timezone"
import useToast from "../../hooks/useToast"

function EventButtonTop({
    profile,
    showToast,
    setIsLoginModalVisible,
    setIsNoTargetModalVisible,
    setIsAfterRegistedVisible,
    setAppsflyerTrackingCode,
    setIsInnerModalVisible,
}) {
    const renderButton = () => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const targetRef = useRef(null)

        const selectedDate = moment.tz(profile?.profileRegisterDateTime, "UTC").tz("Asia/Seoul")
        const comparisonDate = moment.tz("2024-06-24 00:00:00", "Asia/Seoul")
        console.log(profile)
        if (profile == null || !profile?.profileId === 0) {
            return (
                <img
                    src={button1}
                    alt="비로그인"
                    onClick={() => {
                        setIsLoginModalVisible(true)
                    }}
                />
            )
        } else if (profile?.remark === "NANO" || profile?.remark === "BOT") {
            return (
                <img
                    src={button1}
                    alt="나노, 봇계정"
                    onClick={() => {
                        setIsNoTargetModalVisible(true)
                    }}
                />
            )
        } else if (selectedDate.isAfter(comparisonDate)) {
            return <img src={button1} alt="나중 생성된 계정" onClick={() => setIsAfterRegistedVisible(true)} />
        }
        const handleScroll = () => {
            if (targetRef.current) {
                const targetPosition = targetRef.current.getBoundingClientRect().bottom + window.scrollY
                window.scrollTo({
                    top: targetPosition,
                    behavior: "smooth",
                })
            }
        }

        return <img ref={targetRef} src={button1} onClick={handleScroll} alt={"이벤트확인"} />
    }

    return renderButton()
}

export default EventButtonTop
